import React from 'react'
import { Text, ViewStyle, TextStyle } from 'react-native'
import MaskedView from '@react-native-masked-view/masked-view'
import { LinearGradient } from 'expo-linear-gradient'

interface GradientTextProps {
    children: React.ReactNode
    colors: readonly [string, string, ...string[]]
    start?: { x: number; y: number }
    end?: { x: number; y: number }
    style?: TextStyle
}

export const GradientText = ({ children, colors, start = { x: 0, y: 0 }, end = { x: 1, y: 0 }, style = {} }: GradientTextProps) => {
    // Separar el estilo de texto y el estilo de sombra
    const { textShadowColor, textShadowOffset, textShadowRadius, ...maskTextStyle } = style || {}

    return (
        <MaskedView maskElement={<Text style={[maskTextStyle, { backgroundColor: 'transparent' }]}>{children}</Text>}>
            <LinearGradient
                colors={colors}
                start={start}
                end={end}
                style={{ flexDirection: 'row' }} // importante para que el texto entre bien
            >
                <Text
                    style={[
                        style,
                        {
                            opacity: 0, // oculta este texto, solo queremos que el gradiente lo pinte
                        },
                    ]}
                >
                    {children}
                </Text>
            </LinearGradient>
        </MaskedView>
    )
}
